export { default as ScalarIconButton } from "./ScalarIconButton.vue.js";
